/* eslint-disable camelcase */
import { handleActions } from 'redux-actions'

import { CUSTOMER_COOKIE } from 'constants/app-constants'
import { LOGIN, LOGIN_MFA, LOGOUT, ME } from 'constants/auth-constants'
import { createCookie } from 'utils/cookies'
import { isServerError } from 'utils/http'

const initialState = {
  hasError: false,
  errorType: '',
  hasFailed: false,
  submitting: false,
  errors: {},
  authenticated: null,
}

const login = (s, a) => {
  const { current_customer_id } = a.payload.body

  createCookie(CUSTOMER_COOKIE, current_customer_id)

  // Success clears any prior error state (token arrives via httpOnly cookie, not the body).
  return {
    ...s,
    hasError: false,
    hasFailed: false,
    errorType: '',
    errors: {},
    submitting: false,
  }
}

const fail = (s, a) => ({
  ...s,
  hasError: false,
  hasFailed: true,
  submitting: false,
  errors: a.payload,
})

const loginFail = (s, a) => ({
  ...fail(s, a),
  // utils/http attaches the parsed error body as error.body (was error.response.data on the old axios path).
  errorType: a.payload?.error?.body?.error,
})

// A wrong 2FA code is a 4xx (user error → "give it another go"); only 5xx is a real server error.
const mfaFail = (s, a) => {
  const serverError = isServerError(a.payload?.error?.status)
  return { ...fail(s, a), hasError: !serverError, hasFailed: serverError }
}

const loading = (s, _a) => ({
  ...s,
  submitting: true,
})

const ready = (s, _a?: any) => ({
  ...s,
  submitting: false,
})

export default handleActions(
  {
    [`${LOGIN}_START`]: loading,
    // A login replaces the session cookie (pre-2FA when MFA is on), so only me() can confirm the new session.
    [`${LOGIN}_SUCCESS`]: (s, a) => ({ ...login(s, a), authenticated: false }),
    [`${LOGIN}_FAIL`]: loginFail,

    [`${LOGIN_MFA}_START`]: loading,
    [`${LOGIN_MFA}_SUCCESS`]: login,
    [`${LOGIN_MFA}_FAIL`]: mfaFail,

    [`${LOGOUT}_START`]: s => ({ ...s, authenticated: false }),
    [`${LOGOUT}_SUCCESS`]: s => ({ ...ready(s), authenticated: false }),

    [`${ME}_SUCCESS`]: s => ({ ...s, authenticated: true }),
    [`${ME}_FAIL`]: s => ({ ...s, authenticated: false }),
  },
  initialState,
)
